System.register(["./dyn-jsx-runtime.js", "./dyn-index.js", "./dyn-goober.modern.js", "./dyn-embla-carousel-react.esm.js", "./dyn-index2.js"], function(exports, module) {
  "use strict";
  var jsxRuntimeExports, reactExports, j, useEmblaCarousel, useMobile, usePrevNextButtons, PrevButton, NextButton;
  return {
    setters: [(module2) => {
      jsxRuntimeExports = module2.j;
    }, (module2) => {
      reactExports = module2.r;
    }, (module2) => {
      j = module2.j;
    }, (module2) => {
      useEmblaCarousel = module2.u;
    }, (module2) => {
      useMobile = module2.u;
      usePrevNextButtons = module2.a;
      PrevButton = module2.P;
      NextButton = module2.N;
    }],
    execute: function() {
      exports("default", SocialMediaReviews);
      const MainWrapper = j("div")`
  position: relative;
  max-width: 1280px;
  margin: 0 auto;
  margin-top: 24px;
  --slide-size: 33.33%;
  --slide-height: 474px;
  --slide-spacing: 10px;
  @media screen and (max-width: 767px) {
    --slide-size: 85%;
    --slide-height: 378px;
    overflow-x: hidden;
  }
`;
      const Navigator = j("div")`
  position: absolute;
  display: flex;
  justify-content: space-between;
  right: 0;
  top: -96px;
  width: 120px;
  height: 48px;
  .embla__button {
    width: 48px;
    height: 48px;
    padding: 12px;
    background-color: #fff;
    color: black;
    border-radius: 999px;
    cursor: pointer;
  }
  .embla__button--prev {
    transform: translateX(-2px);
  }
  .embla__button--next {
    transform: translateX(2px);
  }
  @media screen and (max-width: 767px) {
    display: none;
  }
`;
      const SlidesViewport = j("div", reactExports.forwardRef)`
  position: relative;
  @media screen and (max-width: 767px) {
    padding: 0 24px;
  }
`;
      const SlidesContainer = j("div")`
  display: flex;
  touch-action: pan-y pinch-zoom;
  margin-left: calc(var(--slide-spacing) * -1);
  margin-right: calc(var(--slide-spacing) * -1);
`;
      const Slide = j("div")`
  flex: 0 0 var(--slide-size);
  min-height: var(--slide-height);
  min-width: 0;
  transform: translate3d(0, 0, 0);
  padding-left: var(--slide-spacing);
  padding-right: var(--slide-spacing);
  box-sizing: border-box;

  .carousel-slide-content {
    position: relative;
    border-radius: 15px;
    padding: 32px 30px 40px;
    text-align: center;
    height: 100%;
    background: rgba(24, 27, 34, 1);

    img {
      height: 43px;
      width: auto;
      margin: 0 auto;
      margin-bottom: 20px;
    }
    h5 {
      font-size: 20px;
      font-weight: 700;
      line-height: 1.2;
    }
    p {
      font-weight: 400;
      font-size: 14px;
      text-align: left;
    }
    .career_title {
      font-size: 16px;
      color: rgba(255, 255, 255, 0.6);
      margin-bottom: 32px;
      text-align: center;
      @media screen and (max-width: 767px) {
        font-size: 12px;
      }
    }
    .footer-link a {
      position: absolute;
      bottom: 32px;
      right: 30px;
      color: rgba(0, 122, 255, 1);
      font-weight: 400;
      font-size: 16px;
      padding-right: 15px;

      &:after {
        content: "";
        position: absolute;
        width: 9px;
        height: 9px;
        right: 0;
        top: 50%;
        box-sizing: border-box;
        transform-origin: center;
        border: 2px solid rgba(0, 122, 255, 1);
        border-top: none;
        border-left: none;
        transform: translateY(-50%) rotate(-45deg);
      }
    }
  }
`;
      function SocialMediaReviews(props) {
        const [emblaRef, emblaApi] = useEmblaCarousel(props.options);
        const [, setSelectedIndex] = reactExports.useState(0);
        const [, setScrollSnaps] = reactExports.useState([]);
        const isMobile = useMobile();
        const onInit = reactExports.useCallback((emblaApi2) => {
          setScrollSnaps(emblaApi2.scrollSnapList());
        }, []);
        const onSelect = reactExports.useCallback((emblaApi2) => {
          setSelectedIndex(emblaApi2.selectedScrollSnap());
        }, []);
        const {
          prevBtnDisabled,
          nextBtnDisabled,
          onPrevButtonClick,
          onNextButtonClick
        } = usePrevNextButtons(emblaApi);
        reactExports.useEffect(() => {
          if (!emblaApi) return;
          onInit(emblaApi);
          onSelect(emblaApi);
          emblaApi.on("reInit", onInit).on("reInit", onSelect).on("select", onSelect);
        }, []);
        return /* @__PURE__ */ jsxRuntimeExports.jsxs(MainWrapper, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Navigator, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(PrevButton, { onClick: onPrevButtonClick, disabled: prevBtnDisabled }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(NextButton, { onClick: onNextButtonClick, disabled: nextBtnDisabled })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(SlidesViewport, { ref: emblaRef, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SlidesContainer, { children: props.items.map((item, index) => /* @__PURE__ */ jsxRuntimeExports.jsx(Slide, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "carousel-slide-content", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: item.logo }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("h5", { children: item.title }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "career_title", children: item.career_title }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { dangerouslySetInnerHTML: {
              __html: isMobile && item.desc_mobile || item.desc
            } }),
            item.link && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "footer-link", children: /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: item.link, target: "_blank", children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: item.link_text }) }) })
          ] }) }, index)) }) })
        ] });
      }
    }
  };
});
